<template>
  <div class="app-user-info">
    <slot />
    <ul>
      <li>{{ label.name }} {{ name }}</li>
      <li>{{ label.rut }} {{ rut }}</li>
      <li v-if="qualification">
        {{ label.speciality }} {{ qualification }}
      </li>
    </ul>
  </div>
</template>

<script>
import _get from 'lodash/get';
import rutHelper from '@/helpers/rut';

export default {
  name: 'AppUserInfo',
  props: {
    user: {
      type: Object,
      required: true
    },
    labeled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    name() {
      return _get(this.user, 'name[0].text');
    },
    rut() {
      try {
        return (this.user.identifier[0].type.coding[0].code == "PPN" ? 'Pasaporte' : 'DNI') + ': ' +
            this.user.identifier[0].value + ' - ' +
            this.user.identifier[0].type.extension[0].valueCodeableConcept.coding[0].display;

      } catch (e){
        //Si cae acá, no es extranjero
      }

      if (this.user.country){
        return (this.user.document_type == 'passport' ? 'Pasaporte' : 'DNI') + ': ' + this.user.id;
      }
      const rutIdentifier = _get(this.user, 'identifier').find(i => i.system.includes('registrocivil'));
      return rutIdentifier ? rutHelper.format(rutIdentifier.value, true) : '';
    },
    qualification() {
      const qualification = _get(this.user, 'qualification[0]');
      return qualification ? qualification.code.text : '';
    },
    label() {
      if (!this.labeled) return {};
      return {
        name: 'Nombre:',
        rut: 'Rut:',
        speciality: 'Especialidad:'
      };
    }
  }
};
</script>

<style lang="scss">
.app-user-info {
  color: $--color-white;
  padding: $--spacing-6;

  ul {
    list-style: none;
    padding: 0;

    li {
      padding-left: $--spacing-6;
    }
  }
}
</style>
